<template>
  <div class="order-list" id="orderList">
    <div class="order-container">
      <!-- tab-item -->
      <nav class="flex">
        <div
          v-for="(tab, index) in tabs"
          class="tab"
          :key="index"
          @click="activeIndex = index"
          :class="{ active: activeIndex === index, 'border-l': activeIndex === index && activeIndex > 0 }"
        >
          <span class="item" :class="{ active: activeIndex === index, 'no-border': activeIndex - 1 === index }">{{
            tab.text
          }}</span>
        </div>
        <div class="flex-grow border-b"></div>
      </nav>
      <!-- tab-content -->
      <div style="min-height: 1060px" v-loading="loading">
        <div v-if="orderList.length">
          <section style="margintop: 10px" class="order" v-for="(item, idx) in orderList" :key="idx">
            <header class="flex">
              <div class="flex-grow title-flex">
                <!-- 活动待开始 -->
                <div v-if="getOrderState(item.startTime, item.endTime).state == 0">
                  {{ dateFormate2(getOrderState(item.startTime, item.endTime).time) }}
                  <span>开始</span>
                </div>
                <!-- 活动竞拍中 -->
                <div v-if="getOrderState(item.startTime, item.endTime).state == 2">
                  <span>预计</span>
                  {{ dateFormate2(getOrderState(item.startTime, item.endTime).time) }}
                  <span>结束</span>
                </div>
                <!-- 活动已结束 -->
                <div v-if="getOrderState(item.startTime, item.endTime).state == 3">
                  {{ dateFormate2(getOrderState(item.startTime, item.endTime).time) }}
                  <span>结束</span>
                </div>
              </div>
            </header>
            <div style="display: flex">
              <div>
                <div class="flex-center main">
                  <div>
                    <!-- <div
                      v-for="(goodsList, index) in attr.orderItemDtoList"
                      class="one-of-order"
                      :key="index"
                      @click="goToDetail(goodsList)"
                      style="cursor: pointer;marginTop:10px"
                    > -->
                    <div class="one-of-order" style="cursor: pointer; margintop: 10px">
                      <div class="flex">
                        <div class="img-container">
                          <img :src="item.mainImage" alt="" />
                        </div>
                        <div class="goods-inf">
                          <div class="title">
                            <span class="activityTag">{{ item.activityTag ? item.activityTag : '拍卖' }}</span>
                            {{ item.itemName }}
                            <!-- <span v-if="goodsList.order.orderType == 8">
                          {{ getSkuText(goods.attributeMap) }}
                        </span> -->
                          </div>
                          <p>
                            <!-- <span
                              style="marginRight:10px"
                              v-for="(item, index) in goodsList.attributeMaps"
                              :key="index"
                            > -->
                            <span style="marginright: 10px">
                              {{ item.skuName }}
                            </span>
                          </p>
                          <p>
                            <span style="marginright: 10px" v-if="item.auctionType == 0"
                              >起拍价：￥{{ item.startPrice / 100 }}</span
                            >
                            <span style="marginright: 10px" v-if="item.auctionType == 1"
                              >当前价：￥{{ item.currentPrice / 100 }}</span
                            >
                            <span
                              style="marginright: 10px"
                              v-if="(item.auctionType == 2 || item.auctionType == 3) && item.finalPrice !== null"
                              >成交价：￥{{ item.finalPrice / 100 }}</span
                            >
                          </p>
                          <p v-if="item.itemType == 0">
                            <span>经销商：{{ item.dealerName }}</span>
                          </p>
                        </div>
                        <div class="align-center status">
                          <div :style="{ color: '#333' }" class="status-text">
                            {{ actionProcess(item.auctionType || 0) }}
                          </div>
                        </div>
                        <div class="align-center price">
                          ￥{{ item.deposit / 100 || 0 }}
                          <p class="tip">
                            保证金
                            <span v-if="now > item.endTime && item.depositType != null"
                              >({{ item.depositType == 1 ? '已扣除' : ' 已退还' }})</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex-grow flex-center">
                <div class="dividing"></div>
                <div class="operation show-btn">
                  <div>
                    <div class="btn pay" v-if="item.auctionType == 1" @click="adRoute(item)">
                      {{ item.reducePriceAuction ? (item.bizNo ? '去购买' : '去应价') : '去出价' }}
                    </div>
                    <div></div>
                    <div
                      class="btn pay"
                      v-if="item.auctionType == 2 && item.depositType !== 1 && item.depositType !== 2"
                      @click="adRoute(item)"
                    >
                      去购买
                    </div>
                    <div class="btn pay" v-if="item.auctionType == 3" @click="checkDetails(item.bizNo)">查看订单</div>
                  </div>
                  <div class="check-btn-flex">
                    <span class="show-underline" @click="adDetails(item)">查看详情</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="line-c" v-if="idx < orderList.length - 1"><div class="line"></div></div>
          </section>
        </div>
        <WithoutData v-else-if="!loading" />
      </div>
    </div>
    <div class="page">
      <el-pagination
        v-show="totalCount > pageSize"
        :pageSize="pageSize"
        :pageCount="pageSize"
        layout=" prev, pager, next, jumper"
        @current-change="pageChange"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import WithoutData from '@/components/common/WithoutData'
import orderApi from '@/api/order.js'
import baseLayout from '@/mixins/baseLayout.vue'
export default {
  name: 'orderList',
  components: {
    WithoutData
  },
  mixins: [baseLayout],
  data() {
    return {
      receivingList: [],
      activityTag: {
        2: '搭配购',
        3: '抽奖类',
        5: '限时抢购',
        6: '团购',
        8: '集客',
        9: '主题',
        10: '投票',
        11: '裂变',
        14: '签到集卡',
        16: '邀请下单',
        18: '预售',
        19: '神券',
        20: '拍卖',
        21: '买赠'
      },
      confirmLoading: false, // 确认收货loading
      showConfirm: false,
      activeIndex: 0,
      tabs: [
        {
          text: '我的竞拍',
          status: ''
        },
        {
          text: '待开始',
          status: 0
        },
        {
          text: '竞价中',
          status: 2
        },
        {
          text: '已结束',
          status: 3
        },
        {
          text: '已拍下',
          status: 4
        }
      ],
      statusText: ['待付款', '待收货', '待发货', '已完成', '已取消', '已付款', '已退款', '已完成'], // 状态字符
      orderList: [
        {
          orderContracts: [],
          order: {
            updatedAt: ''
          }
        }
      ],
      loading: false,
      totalCount: 0,
      pageNo: 1,
      pageSize: 5,
      orderId: '', // 取消订单id
      reasonId: '', // 取消订单获取理由id
      logisticsOrder: null, // 物流order
      cancelIndex: -1,
      paginationShow: true,
      qrcode: '',
      activityExtra: {
        // 活动相关内容
        grouponInfo: null
      },
      isGroup: null, // 团购隐藏退货
      crowdfundingInfo: {},
      logisticsList: [], // 物流信息
      logisticsDialog: false, // 物流弹窗
      orderDelivery: null,
      logisticsLoading: false, // 物流loading
      orderContracts: [],
      now: '' /* 当前时间戳 */,
      reducePriceAuction: false
    }
  },
  created() {
    this.getData()
    this.now = new Date().getTime()
  },
  methods: {
    // handleRealShow(val) {
    //   this.logisticsDialog = val
    // },
    /**
     * @descripttion: 查看拍卖商品
     * @Author: cuiyuan
     * @Date: 2021-01-22 18:30:13
     * @param {obj} item 对应数据
     * @return {void}
     */
    checklogistic(item) {
      if (item.orderDelivery) {
        let obj = {
          expressCode: item.orderDelivery && item.orderDelivery[0].expressCode,
          expressNum: item.orderDelivery && item.orderDelivery[0].expressNum,
          img: item.orderDelivery && item.orderItemDtoList[0].itemImage,
          number: item.orderItemDtoList.length,
          orderItemId: item.orderItemDtoList[0].id,
          expressName: item.orderDelivery && item.orderDelivery[0].expressName
        }
        this.orderDelivery = obj
        // this.logisticsDialog = false
      }
      this.$nextTick(() => {
        this.$refs.log.show = true
      })
    },
    goToOrderDetail(item) {
      this.$router.push(`/personCenter/orderDetail?id=${item.order.id}`)
    },
    // 根据actionType判断当前拍卖的进程
    actionProcess(type) {
      let returnText = ''
      switch (type) {
        case 0:
          returnText = ' 待开始'
          break
        case 1:
          returnText = '  竞价中'
          break
        case 2:
          returnText = '  已结束'
          break
        case 3:
          returnText = ' 已拍下'
          break
      }
      return returnText
    },
    // 点击进入商品详情页
    adRoute(item) {
      if (item.activityStatus === 3) {
        this.$feedback('活动已下架')
        return
      }
      let url = ''
      if (item.itemType === '0' || item.itemType === 0) {
        if (item.activityId) {
          url = `/details/allCars?activityId=${item.activityId}&id=${item.itemId}`
        } else {
          url = `/details/allCars?id=${item.itemId}`
        }
      } else if (item.reducePriceAuction && item.bizNo) {
        url = `/personCenter/orderDetail?id=${item.bizNo}`
      } else {
        if (item.activityId) {
          url = `/details/boutiqueAccessories?activityId=${item.activityId}&id=${item.itemId}`
        } else {
          url = `/details/boutiqueAccessories?id=${item.itemId}`
        }
      }
      this.$router.push(url)
    },
    adDetails(item) {
      if (item.activityStatus === 3) {
        this.$feedback('活动已下架')
        return
      }
      let url = ''
      if (item.itemType === '0' || item.itemType === 0) {
        if (item.activityId) {
          url = `/details/allCars?activityId=${item.activityId}&id=${item.itemId}`
        } else {
          url = `/details/allCars?id=${item.itemId}`
        }
      } else {
        if (item.activityId) {
          url = `/details/boutiqueAccessories?activityId=${item.activityId}&id=${item.itemId}`
        } else {
          url = `/details/boutiqueAccessories?id=${item.itemId}`
        }
      }
      this.$router.push(url)
    },
    goToDetail(item) {
      if (item.itemType === '0') {
        this.$router.push({
          path:
            '/details/allCars?id=' +
            item.itemId +
            (item.extraMap.activity && item.extraMap.activity.activityId
              ? '&activityId=' + item.extraMap.activity.activityId
              : '')
        })
      } else {
        this.$router.push({
          path:
            '/details/boutiqueAccessories?id=' +
            item.itemId +
            (item.extraMap.activity && item.extraMap.activity.activityId
              ? '&activityId=' + item.extraMap.activity.activityId
              : '')
        })
      }
    },
    getData(pageNo) {
      // 传给后端的参数status 0 -> null, 1 -> 3, 2 -> 5, 3 -> 2, 4 -> -80
      const params = {
        pageNo,
        pageSize: this.pageSize
      }
      const transStatus = [null, 0, 1, 2, 3]
      if (this.activeIndex) {
        params.auctionType = transStatus[this.activeIndex]
      }
      orderApi.getMyAuctionList(params).then(
        (res) => {
          const { total, data } = res.data
          this.totalCount = total
          this.orderList = data
        },
        () => {
          this.loading = false
        }
      )
    },
    // 页码切换
    pageChange(pageNo) {
      this.pageNo = pageNo
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      this.getData(pageNo)
    },

    /**
     * @descripttion: 崔源
     * @Author: cuiyuan
     * @Date: 2021-01-21 23:36:50
     * @param {obj} item [当前的订单数据]
     * @return {void}
     */
    jumpAfter(item) {
      this.$router.push(`/personCenter/rejectSubmit?orderId=${item.order.id}&itemType=${item.order.orderType}`)
    },
    /**
     * @descripttion: 崔源
     * @Author: cuiyuan
     * @Date: 2021-01-21 19:59:50
     * @param {number} id [订单id]
     * @return {void}
     */
    checkDetails(id) {
      this.$router.push(`/personCenter/orderDetail?id=${id}`)
    },
    /**
     * @Author: linyl
     * @descripttion:  获取当前的订单状态和时间
     * @Date: 2021-04-20 10:56:51
     * @param {*} sTime 拍卖开始时间
     * @param {*} eTime 拍卖结束时间
     * @return {*} 订单状态和订单需要显示的时间
     */
    getOrderState(sTime, eTime) {
      let obj = {
        time: this.now,
        state: 0
      }
      // 活动待开始
      if (this.now < sTime) {
        obj.time = sTime
        return obj
      } else if (this.now > eTime) {
        // 活动结束/已拍下
        obj.time = eTime
        obj.state = 3
        return obj
      } else {
        // 竞价中
        obj.time = eTime
        obj.state = 2
        return obj
      }
    }
  },
  mounted() {},
  watch: {
    activeIndex() {
      this.paginationShow = false
      this.$nextTick(() => {
        this.paginationShow = true
      })
      this.getData(1)
    }
  }
}
</script>

<style scoped lang="scss">
// ::v-deep .logisticDialog {
//   padding: 0 !important;
// }
@mixin icon($size, $icon, $mr) {
  background: url($icon);
  display: inline-block;
  height: $size;
  width: $size;
  background-size: $size $size;
  margin-right: $mr;
}
nav {
  box-sizing: border-box;
  /*height: 57px;*/
  overflow: hidden;
  .tab {
    @extend .flex-center;
    width: 127px;
    height: 56px;
    box-sizing: border-box;
    border-bottom: 1px solid #d4d4d4;
    cursor: pointer;
    text-align: center;
    span {
      font-size: 14px;
    }
    &.active {
      border-top: 2px #c6001f solid;
      border-right: 1px #d4d4d4 solid;
      color: #c6001f;
      position: relative;
      border-bottom: none;
      &:before {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        display: inline-block;
        content: '';
        width: 0;
        height: 0;
        border-width: 4px 4px 0;
        border-style: solid;
        border-color: #c6001f transparent transparent;
      }
    }
  }
  .item {
    display: inline-block;
    width: 100%;
    height: 20px;
    line-height: 20px;
    border-right: 1px solid #d4d4d4;
    &.active {
      transform: translateY(-1px);
      border-right: 1px solid #fff;
    }
    &.no-border {
      border-right: 1px solid #fff;
    }
  }
}

.codeBox {
  width: 260px;
  height: 315px;
  margin: 0 auto;
  .redBox {
    text-align: center;
    font-size: 20px;
    font-family: MicrosoftYaHei;
    color: #333;
    margin: 16px 0 20px 0;
    span {
      color: #f54358;
    }
    .joinText {
      cursor: pointer;
      color: #f54358;
      text-decoration: underline;
    }
  }
  .groupSuccess {
    margin-top: 0px;
    margin-bottom: 5px;
  }
  .qrcodeBox {
    height: 220px;
    width: 220px;
    margin: 0px auto 0px;
  }
  .shareText {
    text-align: center;
    color: #666;
    display: block;
    font-size: 18px;
    margin: 14px 0 0px 0;
  }
}
.crowdBox {
  width: 260px;
  height: 300px;
  margin: 0 auto;
  .qrcodeBox {
    height: 220px;
    width: 220px;
    margin: 30px auto 0px;
  }
  .gearText {
    text-align: center;
    color: #666;
    display: block;
    font-size: 18px;
    margin: 26px 0 30px 0;
    span {
      color: #c6001f;
    }
  }
}
p {
  font-size: 16px/1;
}
.order-container {
  width: 100%;
  background: #fff;
  box-shadow: 0 1px 5px 1px rgba(224, 224, 224, 0.5);
}

.page {
  height: 32px;
  background: #f9f9f9;
  // position: relative;
  display: flex;
  justify-content: center;
  margin: 40px auto 50px;
}
.order {
  position: relative;
  text-align: left;
  padding: 19px 55px 22px 25px;
  box-sizing: border-box;
  .title-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  header {
    font-size: 14px;
    color: #777;
  }
  .icon-clock {
    @include icon(17px, '../../assets/icons/order/icon-clock.png', 5px);
  }
  .main {
    position: relative;
    padding-top: 14px;
    box-sizing: border-box;
  }
  .orderContracts {
    display: flex;
    flex-direction: column;
    .one-of-order {
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .clr-b7 {
    color: #b7b7b7;
    margin-left: 14px;
  }
  .img-container {
    height: 143px;
    width: 202px;
    cursor: pointer;
    background-size: contain;
    background-repeat: no-repeat;
    img {
      // display: block;
      height: 143px;
      width: 202px;
    }
  }
  .goods-inf {
    width: 377px;
    box-sizing: border-box;
    padding: 0px 14px 0;
    font-size: 16px;
    color: #333;
    .title {
      .groupTag {
        position: relative;
        top: 5px;
      }
      .crowdTag {
        position: relative;
        top: 7px;
      }
      font-weight: 600;
      font-size: 18px;
      line-height: 25px;
    }
    p {
      margin-top: 8px;
    }
  }
  .status {
    // width: 64px;
    // width: 100%;
    width: 96px;
    text-align: center;
    font-size: 16px;
    position: relative;
    .status-text {
      font-weight: bold;
    }
  }
  .price {
    position: relative;
    text-align: center;
    width: 177px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    .tip {
      position: absolute;
      font-size: 12px;
      color: #666;
      left: 50%;
      transform: translateX(-50%);
      top: 21px;
      font-weight: 400;
    }
  }
  .dividing {
    height: 60px;
    width: 2px;
    background: #e0e0e0;
  }
  .show-btn {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    .check-btn-flex {
      display: flex;
      justify-content: space-around;
    }
    .show-underline {
      color: #666666;
      font-size: 14px;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .operation {
    width: 178px;
    text-align: center;
    margin-left: 10px;
    .groupBtn,
    .crowdBtn {
      margin-bottom: 10px;
      ::v-deep {
        .el-button--danger {
          width: 133px;
          height: 40px;
          background-color: #c6001f;
          font-size: 18px;
        }
        .el-button--info {
          width: 133px;
          height: 40px;
          background-color: #333333;
          font-size: 18px;
        }
        .el-button {
          // padding: 8px 0;
          border-radius: 0;
        }
      }
    }
  }
  .line-c {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 0 30px;
    width: 100%;
    height: 1px;
    box-sizing: border-box;
    margin: 1px 0;
  }
  .line {
    height: 1px;
    background: #d4d4d4;
  }
}
.float-l {
  float: left;
}
.flex {
  display: flex;
}
.flex-center {
  display: flex;
  align-items: center;
}
.title {
  display: flex;
  align-items: flex-end;
  .activityTag {
    padding: 0 3px;
    color: #fff;
    background: #df3d36;
    font-weight: 400;
    height: 21px;
    font-size: 16px;
    font-family: PingFangSC;
    font-weight: 500;
    line-height: 21px;
    margin-right: 5px;
  }
  .prizeTab {
    padding: 0 3px;
    height: 21px;
    margin-right: 5px;
  }
}

.flex-grow {
  flex-grow: 1;
}
.align-center {
  align-self: center;
}
.border-b {
  border-bottom: 1px solid #d4d4d4;
}
.border-l {
  border-left: 1px solid #d4d4d4 !important;
}
.color-666 {
  color: #666;
  font-size: 14px;
}
.mt-5 {
  margin-top: 5px;
}
.margin-left20 {
  margin-left: 16px;
}
.margin-left5 {
  margin-left: 5px;
}
.mr-5 {
  margin-right: 5px;
}
.mr-10 {
  margin-right: 10px;
}
.underline {
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #333;
  }
}
.auctionTag {
  display: inline-block;
  // width: 30px;
  padding: 0 3px;
  height: 19px;
  color: #fff;
  font-family: NotoSansHans-Regular;
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  background: #c6001f;
  margin-right: 3px;
  padding: 0 2px;
}
// 确认收货弹窗
.logistic-box {
  .flex-start {
    display: flex;
    align-items: flex-start;
    text-align: left;
    .goods-inf {
      position: relative;
      p {
        position: absolute;
        width: 100%;
        line-height: 28px;
        height: 28px;
        color: #fff;
        text-align: center;
        font-size: 14px;
        bottom: 0;
        background: rgba(37, 37, 37, 0.8);
      }
      img {
        width: 162px;
        height: 114px;
      }
    }
    .express-box {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      .express {
        padding: 3px 25px;
        font-size: 15px;
        color: #333;
        .margin-top5 {
          margin-top: 15px;
        }
        .fw-500 {
          font-weight: 500;
        }
      }
    }
  }
}
// 物流弹窗
::v-deep.logistic-box {
  .flex-start-box {
    display: flex;
    align-items: flex-start;
    text-align: left;
    // .flex-start {
    //   display: flex;
    //   align-items: flex-start;
    //   justify-content: center;
    //   text-align: left;
    .goods-inf {
      position: relative;
      p {
        position: absolute;
        width: 100%;
        line-height: 28px;
        height: 28px;
        color: #fff;
        text-align: center;
        font-size: 14px;
        bottom: 0;
        background: rgba(37, 37, 37, 0.8);
      }
      img {
        width: 162px;
        height: 114px;
      }
    }
    .express-box {
      height: 114px;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      .express {
        padding: 3px 25px;
        font-size: 15px;
        color: #333;
        .margin-top5 {
          margin-top: 15px;
        }
        .fw-500 {
          font-weight: 500;
        }
      }
    }
    // }
  }
}
.btn {
  width: 133px;
  height: 40px;
  color: #fff;
  font-size: 18px;
  line-height: 40px;
  background: #c6001f;
  text-align: center;
  cursor: pointer;
  margin: 40px auto 16px;
  transition: all 0.3s;
  &.pay {
    &:hover {
      background: #ee4039;
    }
  }
  &.black {
    background: #333;
    &:hover {
      background: #444;
    }
  }
  &.blank {
    color: #333;
    border: 1px solid #333;
    background-color: #fff;
    &:hover {
      opacity: 1;
      background-color: #333;
      color: #fff;
    }
  }
}
</style>
